import { buildStars } from 'Functions/rating';
import Swiper, { Pagination, Navigation, Autoplay, EffectFade } from 'swiper';

import "Layouts/default";

import 'Ui/slider';
import 'Ui/tabs';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

const indexProductTabs = document.querySelector('.js-index-product-tabs')

if (indexProductTabs) {
    indexProductTabs.addEventListener('rTab.after.openTab', (event) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const slider = event.target.querySelector('r-slider')

                window.sliderLazyLoad.update()

                if (slider && slider.swiper) {
                    slider.swiper.update()

                    if (slider.swiper.params.cssMode) {
                        slider.swiper.wrapperEl.scrollTo(0, 0)
                    }
                }
            })
        })
    })
}

buildStars()
